var _circle, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 137,
    viewBox: "0 0 136 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 65.5764,
    fill: "#FAFAFA",
    stroke: "#000E4B",
    strokeWidth: 3.15271
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4582 82.2917C52.6526 78.9584 60.4998 77.2917 67.9998 77.2917C75.4998 77.2917 83.2776 78.9584 91.3332 82.2917C99.5276 85.4861 103.625 89.7222 103.625 95V103.958H32.3748V95C32.3748 89.7222 36.4026 85.4861 44.4582 82.2917ZM80.4998 63.125C77.0276 66.5972 72.8609 68.3334 67.9998 68.3334C63.1387 68.3334 58.9721 66.5972 55.4998 63.125C52.0276 59.6528 50.2915 55.4861 50.2915 50.625C50.2915 45.7639 52.0276 41.5973 55.4998 38.125C58.9721 34.5139 63.1387 32.7084 67.9998 32.7084C72.8609 32.7084 77.0276 34.5139 80.4998 38.125C83.9721 41.5973 85.7082 45.7639 85.7082 50.625C85.7082 55.4861 83.9721 59.6528 80.4998 63.125Z",
    fill: "#000E4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.188 120.562C114.188 121.531 115.375 122.016 116.75 122.016C118.125 122.016 119.297 121.531 120.266 120.562C121.266 119.562 121.766 118.375 121.766 117C121.766 115.625 121.266 114.453 120.266 113.484C119.297 112.484 118.125 111.984 116.75 111.984C115.375 111.984 114.188 112.484 113.188 113.484C112.219 114.453 111.734 115.625 111.734 117C111.734 118.375 112.219 119.562 113.188 120.562ZM113.75 107.016H119.75L121.578 108.984H124.766C125.297 108.984 125.75 109.188 126.125 109.594C126.531 110 126.734 110.469 126.734 111V123C126.734 123.531 126.531 124 126.125 124.406C125.75 124.812 125.297 125.016 124.766 125.016H108.734C108.203 125.016 107.734 124.812 107.328 124.406C106.953 124 106.766 123.531 106.766 123V111C106.766 110.469 106.953 110 107.328 109.594C107.734 109.188 108.203 108.984 108.734 108.984H111.922L113.75 107.016ZM114.5 119.25C113.875 118.625 113.562 117.875 113.562 117C113.562 116.125 113.875 115.375 114.5 114.75C115.125 114.125 115.875 113.812 116.75 113.812C117.625 113.812 118.375 114.125 119 114.75C119.625 115.375 119.938 116.125 119.938 117C119.938 117.875 119.625 118.625 119 119.25C118.375 119.875 117.625 120.188 116.75 120.188C115.875 120.188 115.125 119.875 114.5 119.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoIcon);
export default __webpack_public_path__ + "static/media/AddPhotoIcon.9fb5979b02083de537c9fdfa76900927.svg";
export { ForwardRef as ReactComponent };